export default {"src":"/_next/static/media/ship-schools-text-only.ef92b710.svg","height":16,"width":79,"blurWidth":0,"blurHeight":0};